<ion-row class="p0 box-shadow">
  <ion-col size="12">
    <div class = "jobPosition care-plan" *ngIf="carePlans?.length || otherCarePlans?.length">
      <p class="input-label task-label">
        <span>Care plan <span *ngIf="title">for {{title}}</span></span>
      </p>

      <div class = "static-select-width">
        <div>
          <ion-select class="position select-font task-select"
            [ngModel]="selectedCarePlanId" [ngModelOptions]="{standalone: true}"
            [interfaceOptions]="carePlanInterfaceOptions"
            (ionChange)="handleCarePlanSelection($event.detail.value)">
            <ion-select-option [value]="noCarePlan">None</ion-select-option>
            <ion-select-option *ngFor="let carePlan of carePlans" [value]="carePlan._id">
              {{ carePlan.name }}
            </ion-select-option>
            <ion-select-option *ngFor="let carePlan of otherCarePlans" [value]="carePlan._id">
              {{ carePlan.name }} (other)
            </ion-select-option>
          </ion-select>
          <i class="fas fa-chevron-down"></i>
        </div>
      </div>
    </div>

    <div class = "jobPosition">
      <p class="input-label task-label">
        <span>Tasks <span *ngIf="title">for {{title}}</span></span>
        <span class="add-link" (click)="showAddTaskModal()"><i  class="fas fa-plus"></i> Add New</span>
      </p>
     
      <div class = "static-select-width" style = "display: flex; flex-direction: column !important;">
        <div>
          <ion-select class="position select-font task-select" placeholder="Select a Task"
            [(ngModel)]="selectedTaskId" [ngModelOptions]="{standalone: true}"
            [interfaceOptions]="interfaceOptions"
            (ionChange)="handleTaskSelection($event.detail.value)">
            <ion-select-option *ngFor="let task of taskOptions" [value]="task._id">
              {{ task.title || task.name }}
            </ion-select-option>
          </ion-select>
          <i class="fas fa-chevron-down"></i>
        </div>
        <table *ngIf= "tasks?.length">
          <tbody>
            <tr class = "table-row table-header">
              <td class = "table-name">Task Name</td>
              <td class = "table-description">Task Description</td>
            </tr>
            <tr *ngFor="let task of tasks" class = "selectedTasks">
              <td class = "task-tab table-name"> 
                <div class = "inner-tab">
                  <span class = "task-title">{{ task.title || task.name }}</span> <i class="fas fa-times" (click)="handleTaskRemoval(task)"></i></div>
              </td>
              <td class = "table-description">
                <div class = "description"><span>{{ task.description}}</span></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ion-col>
</ion-row>